module.exports = __webpack_public_path__ + "static/img/mobile_registery.beeab6a7.png";